import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=4aea9f23&"
import script from "./WidgetForm.vue?vue&type=script&lang=js&"
export * from "./WidgetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports